import * as React from "react";
const SvgPlus20 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M9.25 16.875a.75.75 0 0 0 1.5 0V10.75h6.125a.75.75 0 0 0 0-1.5H10.75V3.125a.75.75 0 1 0-1.5 0V9.25H3.125a.75.75 0 1 0 0 1.5H9.25v6.125Z" }));
const ForwardRef = React.forwardRef(SvgPlus20);
export default ForwardRef;
